import {
  useRef 
} from "react"

import {
  useStyle 
} from "@/classify"
import {
  useScrollIntoView 
} from "@/common/hooks/useScrollIntoView"
import {
  useFormError 
} from "@/hooks/FormError/useFormError"
import ErrorMessage from "../ErrorMessage"
import defaultClasses from "./formError.module.css"

const FormError = (props) => {
  const {
    classes: propClasses,
    errors,
    scrollOnError = true,
    allowErrorMessages,
    message = "",
  } = props
  const talonProps = useFormError({
    errors, allowErrorMessages 
  })

  const {
    errorMessage 
  } = talonProps

  const errorRef = useRef(null)

  useScrollIntoView(errorRef, scrollOnError && errorMessage)

  const classes = useStyle(defaultClasses, propClasses)

  return errorMessage ? (
    <ErrorMessage classes={classes} ref={errorRef}>
      {message || errorMessage}
    </ErrorMessage>
  ) : null
}

export default FormError
